













































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { gallerys } from "@/config/host.config";

import InputSearch from "@/components/app/search/input-search.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";
import GalleryCategorys from "@/components/tables/gallery/gallery-categorys.vue";

import { ICategory } from "@/@types/gallsery/gallery";
import axios from "@/api/AuthAPI/auth-request-api";
import { deleteElement } from "@/api/delite/delite-element";

@Component({
  components: {
    InputSearch,
    ChangeDeliteButtons,
    GalleryCategorys,
    ContextMenu,
  },
})
export default class GalleryFolderRecuclerList extends Vue {
  @Inject("folder") readonly folder!: string;
  @Inject("foldersbg") readonly foldersbg!: string;
  @Prop({ type: Array, default: () => [] }) folders!: Array<ICategory>;
  search = "";

  constxtID = "";
  $refs!: {
    menu: ContextMenu;
  };

  get categorys(): Array<ICategory> {
    return this.folders.filter((el) => {
      return (
        this.$getLocale(el.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  handler(e: PointerEvent, id: string | undefined): void {
    e.preventDefault();
    if (!id) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = id;
    });
  }

  async clearCart(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete-all")),
        }
      );

      if (result === true) {
        this.folders.forEach((f) => {
          if (f._id) this.deleteFolder(f._id);
        });
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  deleteFolder(id: string): void {
    const uri = gallerys.categotysForce;
    deleteElement(id, uri)
      .then(() => {
        this.$emit("update", id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        return;
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  async restoreFormat(id: string | undefined): Promise<void> {
    if (!id) return;
    const uri = gallerys.categotysRestore + "/" + id;
    try {
      const res = await axios.put(uri);
      if (res.status === 200) {
        this.$emit("updateCategory", id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }
}
